/**
 * @param {{STRING}} searchType  /maf   ||   ///
 * @param {{STRING}} searchTerm  /// pizza.beep.sports
 * @var {{FUNCTION}} w3wInputHelper parse searchTerm using loop and regex
 * @var {{FUNCTION}} isValidADRSearchTerm check searchTerm for scheme 'tel'
 */

export const w3wInputHelper = (searchType, searchTerm) => {
  const alphaRegex = /^[a-zA-Z]+$/i;
  let cleanTerm = searchTerm.trim();
  if (searchTerm.includes(searchType)) {
    cleanTerm = searchTerm.split(searchType)[1].trim();
  }
  let parsedTerm = '';
  let spaceOrDots = 0;
  let wordCount = 0;
  let wasSpaceOrDots = false;

  for (let i = 0; i < cleanTerm.length; i++) {
    let char = cleanTerm[i];
    if (char === ' ' || char === '.') {
      if (!wasSpaceOrDots) {
        parsedTerm += '.';
        spaceOrDots++;
        wordCount++;
        wasSpaceOrDots = true;
      }
    } else if (alphaRegex.test(char)) {
      parsedTerm += char;
      if (wasSpaceOrDots) {
        wasSpaceOrDots = false;
      }
    } else {
      return false;
    }
  }
  if (alphaRegex.test(parsedTerm[parsedTerm.length - 1])) {
    wordCount++;
  }
  if (spaceOrDots === 2 && wordCount === 3) {
    return parsedTerm;
  } else {
    return false;
  }
};

export const isW3WSearchTerm = searchTerm => {
  return searchTerm.includes('///');
};

export const isADRSearchTerm = searchTerm => {
  const prefix = '/';
  return searchTerm[0] === prefix && searchTerm[1] !== prefix;
};

export const isValidADRSearchTerm = searchTerm => {
  const rg = /^[0-9\s-]+$/i; // only digits and dashes
  const splitQuery = searchTerm.split('/');
  let cleanTermWithDashes = splitQuery[1].trim();
  let cleanTerm = cleanTermWithDashes.replaceAll('-', '');
  if (rg.test(cleanTerm)) {
    if (cleanTerm.length < 10 || cleanTerm.length > 11) {
      return false;
    } else {
      if (
        (cleanTerm.length === 10 && cleanTerm[0] !== '1') ||
        (cleanTerm.length === 11 && cleanTerm[0] === '1')
      ) {
        return cleanTerm;
      }
    }
  }
  return false;
};

export const isLatLongSearchTerm = searchTerm => {
  if (!searchTerm || !searchTerm.trim()) {
    return false;
  }
  const trimmedTerm = searchTerm.trim();

  // Check if it contains a comma (required for lat,long format)
  if (!trimmedTerm.includes(',')) {
    return false;
  }

  // Split by comma and handle optional spaces
  const parts = trimmedTerm.split(',').map(part => part.trim());

  // Must have exactly 2 parts (latitude and longitude)
  if (parts.length !== 2) {
    return false;
  }

  const [latStr, longStr] = parts;

  // Both parts must not be empty
  if (!latStr || !longStr) {
    return false;
  }

  // Convert to numbers and validate
  const lat = parseFloat(latStr);
  const long = parseFloat(longStr);

  // Check if conversion was successful (not NaN)
  if (isNaN(lat) || isNaN(long)) {
    return false;
  }

  // Validate latitude range (-90 to 90)
  if (lat < -90 || lat > 90) {
    return false;
  }

  // Validate longitude range (-180 to 180)
  if (long < -180 || long > 180) {
    return false;
  }

  return [lat, long];
};

/**
 * Normalize reverse geocode response to match expected format for PinnedMapPopover
 * @param {Object} response - The response from reverseGeocodeLocationToAddress
 * @param {number} originalLat - The original latitude used for the search
 * @param {number} originalLong - The original longitude used for the search
 * @returns {Object} Normalized location object with location and attributes
 */
export const normalizeReverseGeocodeResponse = (
  response,
  originalLat,
  originalLong,
) => {
  // If response is already in the expected format, return as is
  if (
    response?.location?.x !== undefined &&
    response?.location?.y !== undefined
  ) {
    return response;
  }

  // Extract address object fields
  const addressObj = response?.addressObject || {};

  // Normalize the response to match expected format
  const normalizedResponse = {
    location: {
      x: originalLong, // longitude
      y: originalLat, // latitude
    },
    attributes: {
      PlaceName: response?.PlaceName || addressObj?.home || '',
      StAddr: response?.StAddr || addressObj?.street || addressObj?.home || '',
      SubAddr: response?.SubAddr || '',
      City: response?.City || addressObj?.city || '',
      RegionAbbr: response?.RegionAbbr || addressObj?.region || '',
      Postal: response?.Postal || addressObj?.postal_code || '',
      MetroArea: response?.MetroArea || '',
      Region: response?.Region || addressObj?.region || '',
      Zone: response?.Zone || '',
      LongLabel:
        response?.LongLabel ||
        response?.address ||
        `${originalLat}, ${originalLong}`,
      Addr_type: response?.Addr_type || 'reverse_geocode',
      Loc_name: 'World',
      Country: response?.Country || addressObj?.country || '',
    },
  };

  return normalizedResponse;
};
